import React from 'react';
import './Problems.css';
import { useComponentAnalytics } from '../hooks/useAnalytics';

const Problems = () => {
  const { trackInteraction } = useComponentAnalytics('Problems');

  const problems = [
    {
      id: 1,
      icon: '📚',
      title: 'El Costo de la Desinformación',
      subtitle: 'Información dispersa que frena tu empresa',
      description: 'Información aislada, desactualizada e inaccesible en innumerables herramientas (Confluence, Github, Drive, CSV\'s y correos):',
      impacts: [
        {
          icon: '⏱️',
          text: 'Ralentiza la toma de decisiones críticas',
          detail: 'Los equipos pierden tiempo buscando información en múltiples sistemas'
        },
        {
          icon: '🔄',
          text: 'Equipos pierden productividad en tareas repetitivas',
          detail: 'Trabajo redundante por falta de visibilidad del conocimiento existente'
        },
        {
          icon: '📉',
          text: 'La desorganización erosiona la velocidad e innovación',
          detail: 'El caos informativo impide escalar y crecer de manera eficiente'
        }
      ]
    },
    {
      id: 2,
      icon: '⚠️',
      title: 'Uso Indiscriminado y Riesgoso de IA',
      subtitle: 'IA sin control = riesgo empresarial',
      description: 'Muchas organizaciones habilitan el acceso a herramientas de IA (ChatGPT, Copilot, Gemini) sin control ni estrategia. Esto implica:',
      impacts: [
        {
          icon: '🔓',
          text: 'Fugas de información sensible',
          detail: 'Datos confidenciales expuestos a sistemas externos sin gobernanza'
        },
        {
          icon: '💸',
          text: 'Gasto innecesario en tokens',
          detail: 'Uso descontrolado que aumenta costos sin visibilidad del ROI'
        },
        {
          icon: '❌',
          text: 'Falta de gobernanza sobre cómo, quién y para qué se usa la IA',
          detail: 'Sin políticas claras, auditoría ni control de accesos'
        }
      ]
    }
  ];

  const handleProblemInteraction = (problemId, problemTitle) => {
    trackInteraction('problem_view', 'section', {
      problem_id: problemId,
      problem_title: problemTitle
    });
  };

  return (
    <section id="problemas" className="problems section">
      <div className="container">
        <h2 className="section-title">Los Problemas que Resolvemos</h2>
        <p className="section-subtitle">
          Dos desafíos críticos que enfrentan las empresas modernas en la era de la IA
        </p>
        
        <div className="problems-grid">
          {problems.map((problem, index) => (
            <div 
              key={problem.id} 
              className="problem-card fade-in-up"
              style={{ animationDelay: `${index * 0.2}s` }}
              onMouseEnter={() => handleProblemInteraction(problem.id, problem.title)}
            >
              <div className="problem-header">
                <div className="problem-icon">{problem.icon}</div>
                <div className="problem-title-group">
                  <span className="problem-number">Problema {problem.id}</span>
                  <h3 className="problem-title">{problem.title}</h3>
                  <p className="problem-subtitle">{problem.subtitle}</p>
                </div>
              </div>
              
              <div className="problem-content">
                <p className="problem-description">{problem.description}</p>
                
                <div className="problem-impacts">
                  {problem.impacts.map((impact, idx) => (
                    <div key={idx} className="impact-item">
                      <div className="impact-header">
                        <span className="impact-icon">{impact.icon}</span>
                        <span className="impact-text">{impact.text}</span>
                      </div>
                      <p className="impact-detail">{impact.detail}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="problems-cta">
          <div className="cta-content">
            <h3>¿Te suenan familiares estos problemas?</h3>
            <p>ExpertMind fue diseñado específicamente para resolverlos</p>
            <a href="#solucion" className="btn btn-primary">
              <span>Ver nuestra solución</span>
              <span className="btn-icon">→</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Problems;
